import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { SIGN_IN } from './constants';

export const initSignIn = extendRoutine(createRoutine(SIGN_IN), 'RESET');
